/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Topic_SalesInputs */

const en_contact_topic_sales = /** @type {(inputs: Contact_Topic_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Before signing up`)
};

const pl_contact_topic_sales = /** @type {(inputs: Contact_Topic_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przed rejestracją`)
};

/**
* | output |
* | --- |
* | "Before signing up" |
*
* @param {Contact_Topic_SalesInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const contact_topic_sales = /** @type {((inputs?: Contact_Topic_SalesInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Topic_SalesInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_contact_topic_sales(inputs)
	return en_contact_topic_sales(inputs)
});